export const RadnoVrijemeEvdResourceDE: RadnoVrijemeEvdInterface = {
  title: "Arbeitszeitnachweis",
  nextButton: "Nachweis speichern",
  description:
    "Bitte wählen Sie den Zeitraum aus, in dem sich der Arbeitszeitnachweis befindet.",
  inputFields: {
    endDate: {
      label: "Enddatum",
    },
    startDate: {
      label: "Startdatum",
    },
    entryType: {
      error: "Bitte wählen Sie den Arbeitszeitnachweis-Typ aus.",
      label: "Arbeitszeitnachweis-Typ",
      name: "entryType",
      placeholder: "Arbeitszeitnachweis-Typ auswählen",
    },
    napomena: {
      error: "Bitte geben Sie eine Notiz ein.",
      label: "Notiz",
      name: "napomena",
      placeholder: "Notiz bei Bedarf eingeben",
    },
    pocetak: {
      error: "Bitte geben Sie den Arbeitszeitbeginn ein.",
      label: "Arbeitszeitbeginn",
      name: "pocetak",
      placeholder: "Bitte geben Sie den Arbeitszeitbeginn ein",
    },
    zavrsetak: {
      error: "Bitte geben Sie das Arbeitszeitende ein.",
      label: "Arbeitszeitende",
      name: "zavrsetak",
      placeholder: "Bitte geben Sie das Arbeitszeitende ein",
    },
    pocetakPauze: {
      error: "Bitte geben Sie den Pausenbeginn ein.",
      label: "Pausenbeginn",
      name: "pocetakPauze",
      placeholder: "Bitte geben Sie den Pausenbeginn ein",
    },
    zavrsetakPauze: {
      error: "Bitte geben Sie das Pausenende ein.",
      label: "Pausenende",
      name: "zavrsetakPauze",
      placeholder: "Bitte geben Sie das Pausenende ein",
    },
  },
  errors: {
    errorDeleting:
      "Beim Löschen des Arbeitszeitnachweises ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator.",
    errorLoading:
      "Beim Laden des Arbeitszeitnachweises ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator.",
    errorUpdating:
      "Beim Speichern des Arbeitszeitnachweises ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator.",
    errorMissingFields:
      "Bitte füllen Sie die Pflichtfelder aus - Arbeitszeittyp, Arbeitszeitbeginn und Arbeitszeitende.",
    errorPeriodLocked:
      "Der Zeitraum für das gewählte Datum ist gesperrt. Änderungen sind nicht möglich, bis der Manager den Zeitraum wieder öffnet.",
    errorDuplicateEntry:
      "Für diesen Tag existiert bereits ein Eintrag mit demselben Typ und denselben Zeiten. Tip oder Zeiten ändern.",
  },
  types: {
    placeholder: "Bitte wählen Sie den Arbeitszeittyp aus",
    radnovrijeme: "Arbeitszeit",
    dezura: "Bereitschaftsdienst",
    odsustvo: "Abwesenheit",
    bolovanje: "Krankenstand",
    slobodandan: "Freier Tag",
    pripravnost: "Bereitschaft",
    radusmjenama: "Schichtarbeit",
    terenskirad: "Außendienstarbeit",
  },
  successModal: {
    title: "Erfolgreich zur Datenbank hinzugefügt",
    body: "Der Arbeitszeiteintrag wurde erfolgreich gespeichert. Sie können mit Änderungen oder Updates fortfahren.",
    buttonOk: "OK",
  },
};

interface InputFieldInterface {
  label: string;
  name: string;
  placeholder: string;
  error: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

export interface RadnoVrijemeEvdInterface {
  successModal: SuccessModal;
  title: string;
  description: string;
  nextButton: string;
  inputFields: {
    startDate: {
      label: string;
    };
    endDate: {
      label: string;
    };
    entryType: InputFieldInterface;
    pocetak: InputFieldInterface;
    zavrsetak: InputFieldInterface;
    napomena: InputFieldInterface;
    pocetakPauze: InputFieldInterface;
    zavrsetakPauze: InputFieldInterface;
  };
  errors: {
    errorLoading: string;
    errorUpdating: string;
    errorDeleting: string;
    errorMissingFields: string;
    errorPeriodLocked: string;
    errorDuplicateEntry: string;
  };
  types: {
    placeholder: string;
    radnovrijeme: string;
    dezura: string;
    odsustvo: string;
    bolovanje: string;
    slobodandan: string;
    pripravnost: string;
    radusmjenama: string;
    terenskirad: string;
  };
}
